import React from 'react';
import Backend from '../../../Layouts/Backend';
import { withTranslation } from 'react-i18next';
import { Form, FormGroup, Label, CustomInput } from 'reactstrap';
import { Formik } from 'formik';
import { validationSchema } from './validation';
import Moment from 'moment';
import MonitoringPoints from '../../../UI/MonitoringPoints';
import TimeSelector from '../../../UI/TimeSelector';
import { Alert, Button, Dropdown } from '../../../UI/Common';
import ReactSelect from '../../../UI/ReactSelect';

const groupHours = [
  { value: '1', label: 'Hour' },
  { value: '24', label: 'Day' },
  { value: '168', label: 'Week' },
  { value: '672', label: 'Month' },
];

const StatisticsDetailPage = ({ t, ...props }) => {
  const form = {
    groupId: undefined,
    sensorIds: [],
    fromDate: Moment().startOf('month').toDate(),
    toDate: new Date(),
    groupHours: '1',
  };
  const [selectedGroup, setSelectedGroup] = React.useState({});
  function getGroup(groupId) {
    const _group = props.groups.filter((id) => groupId === id);
  }
  return (
    <Backend>
      <div className="content-inner">
        <Alert.Error text={props.errors} />
        <Formik
          initialValues={form}
          validationSchema={validationSchema}
          onSubmit={(values) => props.onRunReport(values)}
        >
          {({
            values,
            handleChange,
            errors,
            setFieldTouched,
            setFieldValue,
            touched,
            handleSubmit,
          }) => {
            return (
              <>
                <Form>
                  <ReactSelect
                    required
                    containerStyle={{ width: '30%' }}
                    label="Group"
                    options={props.groups}
                    value={values.groupId}
                    onChange={({ value }) => {
                      setFieldValue('groupId', value);
                      getGroup(value);
                    }}
                    valueKey="id"
                    labelKey="name"
                    invalid={touched.groupId}
                    error={errors.groupId}
                  />
                  <MonitoringPoints
                    groupId={values.groupId}
                    onSelect={(sensorIds) => {
                      setFieldTouched('sensorIds', false);
                      setFieldValue('sensorIds', sensorIds);
                    }}
                    invalid={errors.sensorIds && touched.sensorIds}
                    error={errors.sensorIds}
                  />
                  <TimeSelector
                    onlyHour
                    onChange={(fromDate, toDate) => {
                      setFieldValue('fromDate', fromDate);
                      setFieldValue('toDate', toDate);
                    }}
                  />
                  <FormGroup>
                    <Label>{t('Group Statistics By')}</Label>
                    <div>
                      {groupHours.map((groupHour) => (
                        <CustomInput
                          key={groupHour.value}
                          type="radio"
                          id={`${groupHour.value}${groupHour.label}`}
                          value={groupHour.value}
                          label={t(groupHour.label)}
                          checked={values.groupHours === groupHour.value}
                          onChange={(e) =>
                            setFieldValue('groupHours', e.target.value)
                          }
                          inline
                        />
                      ))}
                    </div>
                  </FormGroup>
                  <Button
                    id="submit-filter"
                    type="submit"
                    loading={props.isFetching}
                    onClick={handleSubmit}
                  >
                    <i className="md-icon">filter_alt</i>
                    {t('Run report')}
                  </Button>
                </Form>
              </>
            );
          }}
        </Formik>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(StatisticsDetailPage);
